import React from 'react';
import PropTypes from 'prop-types';
import { creditCardImageDict } from './creditCardImageList';

const IMAGE_ASPECT_RATIO = 1.633333;
const IMAGE_WIDTH = 80;

export const CreditCardImage = ({ card, isHighlighted }) => {
    const image = creditCardImageDict[card];
    return image &&
        (
            <img
                width={IMAGE_WIDTH}
                height={Math.round(IMAGE_WIDTH / IMAGE_ASPECT_RATIO)}
                src={image}
                alt={card}
                className={`creditcard__img ${isHighlighted ? 'highlighted' : ''}`}
            />
        )
};

CreditCardImage.propTypes = {
    card: PropTypes.string.isRequired,
    isHighlighted: PropTypes.bool.isRequired
};
